import { UserModel } from "../../models/persisted/userModel";
import { store } from "../../redux/store";

export const verificarPermissaoEmpresa = (): boolean => {
  const usuario: UserModel = store.getState().persisted.user;
  const idEmpresaPermissao = store.getState().configuracoes.idEmpresaPermissao;

  if (usuario.empresas === null) {
    return true;
  }

  // If all empresas have permissao === false, return false
  if (usuario.empresas.length > 0 && usuario.empresas.every(emp => emp.permissao === false)) {
    return false;
  }

  if (usuario.empresa === null) {
    let empresa = usuario.empresas.find((emp) => emp.idEmpresa === idEmpresaPermissao);
    return empresa?.permissao ?? true;
  } else {
    return usuario.empresa.permissao;
  }
};
